import poolSquareImg from "assets/pool-square.svg";
import poolRectangularImg from "assets/pool-rec.svg";
import poolCircleImg from "assets/pool-circle.svg";
import poolKidneyImg from "assets/pool-kidney.svg";

export const POOL_SHAPES = [
  { id: "square", label: "Square", img: poolSquareImg, alt: "Square Pool" },
  {
    id: "rectangular",
    label: "Rectangular",
    img: poolRectangularImg,
    alt: "Rectangular Pool",
  },
  { id: "circle", label: "Circle", img: poolCircleImg, alt: "Circle Pool" },
  {
    id: "kidney",
    label: "Kidney",
    img: poolKidneyImg,
    alt: "Kidney-shaped Pool",
  },
];

export const boostOptions = [
  { label: "6 hours", value: 6 },
  { label: "12 hours", value: 12 },
  { label: "18 hours", value: 18 },
  { label: "24 hours", value: 24 },
];

export const backwashOptions = [
  { label: "2 minutes", value: 2 },
  { label: "3 minutes", value: 3 },
  { label: "4 minutes", value: 4 },
  { label: "5 minutes", value: 5 },
];
